<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <!-- Logo -->
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/logo/its_logo_horizontal.png" alt="Nimble Logo" class="mx-auto" width="250">
            </div>

            <!-- Content -->
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">

                <!-- Loading state -->
                <div v-if="status === 'loading'" class="text-center">
                  <div class="vx-card__title mb-6">
                    <h4 class="mb-4">Confirming Email Change</h4>
                    <p class="text-grey">Please wait while we verify your request...</p>
                  </div>
                  <vs-icon icon="hourglass_empty" icon-pack="material-icons" size="4rem" color="primary" class="mb-4" />
                </div>

                <!-- Success state -->
                <div v-else-if="status === 'success'" class="text-center">
                  <div class="vx-card__title mb-6">
                    <h4 class="mb-4">Email Updated Successfully</h4>
                    <p class="text-grey">Your email address has been updated. You can now log in with your new email.</p>
                  </div>
                  <vs-icon icon="check_circle" icon-pack="material-icons" size="4rem" color="success" class="mb-6" />
                  <vs-button class="w-full" to="/pages/login">Go to Login/Dashboard</vs-button>
                </div>

                <!-- Expired token state -->
                <div v-else-if="status === 'expired'" class="text-center">
                  <div class="vx-card__title mb-6">
                    <h4 class="mb-4">Link Expired</h4>
                    <p class="text-grey">This email confirmation link has expired. Please request a new email update from your profile settings.</p>
                  </div>
                  <vs-icon icon="schedule" icon-pack="material-icons" size="4rem" color="warning" class="mb-6" />
                  <vs-button class="w-full" type="border" to="/pages/login">Go to Login</vs-button>
                </div>

                <!-- Invalid / error state -->
                <div v-else-if="status === 'error'" class="text-center">
                  <div class="vx-card__title mb-6">
                    <h4 class="mb-4">Invalid Link</h4>
                    <p class="text-grey">{{ errorMessage || 'This confirmation link is invalid or has already been used.' }}</p>
                  </div>
                  <vs-icon icon="error_outline" icon-pack="material-icons" size="4rem" color="danger" class="mb-6" />
                  <vs-button class="w-full" type="border" to="/pages/login">Go to Login</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessages from '@/mixins/ErrorMessages'
const StaffRepository = RepositoryFactory.get('staff')

export default {
  name: 'EmailChangeConfirm',
  mixins: [ErrorMessages],
  data () {
    return {
      // 'loading' | 'success' | 'expired' | 'error'
      status: 'loading',
      errorMessage: '',
    }
  },
  async mounted () {
    await this.confirmEmailChange()
  },
  methods: {
    async confirmEmailChange () {
      const token = this.$route.params.token
      try {
        await StaffRepository.confirmEmailChange({ token })
        this.status = 'success'
      } catch (e) {
        const response = e.response
        const data = response && response.data ? response.data : {}
        const message = data.message || data.error || ''

        // Treat expired/invalid tokens distinctly when possible
        if (
          (response && response.status === 410) ||
          /expired/i.test(message)
        ) {
          this.status = 'expired'
        } else {
          this.status = 'error'
          this.errorMessage = message
        }
      }
    }
  }
}
</script>
